import { connect } from 'react-redux';
import SideNav from './SideNav';
function mapStateToProps(state) {
  return {
    menuItems: state.menuItems,
    appFilterCount: state.appFilters ? state.appFilters.filterTypes.length : 0
  };
}
export default connect(mapStateToProps)(SideNav);